function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.min.css';
export default {
  name: 'Select2MultipleControl',
  data: function data() {
    return {
      select2: null
    };
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  props: {
    placeholder: {
      type: String,
      "default": ''
    },
    options: {
      type: Array,
      "default": []
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    settings: {
      type: Object,
      "default": function _default() {}
    },
    value: null
  },
  watch: {
    options: function options(val) {
      this.setOption(val);
    },
    value: function value(val) {
      this.setValue(val);
    }
  },
  methods: {
    setOption: function setOption() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      this.select2.empty();
      this.select2.select2(_objectSpread(_objectSpread({}, this.settings), {}, {
        data: val
      }));
      this.setValue(this.value);
    },
    setValue: function setValue(val) {
      if (val instanceof Array) {
        this.select2.val(_toConsumableArray(val));
      } else {
        this.select2.val([val]);
      }

      this.select2.trigger('change');
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.select2 = $(this.$el).find('select').select2(_objectSpread(_objectSpread({}, this.settings), {}, {
      data: this.options
    })).on('select2:select select2:unselect', function (ev) {
      var _ev$params$data = ev['params']['data'],
          id = _ev$params$data.id,
          text = _ev$params$data.text,
          selected = _ev$params$data.selected;

      var selectValue = _this.select2.val();

      _this.$emit('change', selectValue);

      _this.$emit('select', {
        id: id,
        text: text,
        selected: selected
      });
    });
    this.setValue(this.value);
  },
  beforeDestroy: function beforeDestroy() {
    this.select2.select2('destroy');
  }
};